import { Stack, Text } from '@mantine/core';
import { GroupPickerProps } from './types';
import { groupPicker, groupPickerVariant } from './styles/index.css';
import { useTranslation } from 'react-i18next';
import { Center } from '@mantine/core';
import { palette } from '@app/shared/ui-kit/colors';
import GroupCheckbox from '../GroupCheckbox';

export default function GroupPicker({
  groups,
  selectedGroups,
  withoutTitle = false,
  variant = 'row',
  className = '',
  onToggleGroup,
  onSelectGroup,
  onUnselectGroup,
  ...props
}: GroupPickerProps) {
  const { t } = useTranslation('Group');

  return groups.length === 0 ? (
    <Center w="100%">
      <Center
        p="xs"
        c={palette.blackroomLightGray5}
        fz="sm"
        fw="bold"
        w="100%"
        maw={240}
        ta="center"
      >
        {t('PageGroups.noGroups')}
      </Center>
    </Center>
  ) : (
    <Stack align="stretch" gap={5}>
      {withoutTitle === false && (
        <Text fw="bold" c={palette.blackroomDarkGray4} py={5} px={10} fz="sm">
          {t('Group:Common.groups')}
        </Text>
      )}

      <Stack
        className={`${groupPicker} ${groupPickerVariant[variant]} ${className}`}
        {...props}
      >
        {groups.map((group) => (
          <GroupCheckbox
            key={group.id}
            group={group}
            active={selectedGroups.some(
              (selectedGroup) => selectedGroup.id === group.id,
            )}
            onToggleGroup={onToggleGroup}
            onSelectGroup={onSelectGroup}
            onUnselectGroup={onUnselectGroup}
          />
        ))}
      </Stack>
    </Stack>
  );
}
